import { Button, Collapse, Fade } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";

export default function Monthly() {
  const { id, variant_id } = useParams();
  const navigate = useNavigate();
  const [value1, setValue1] = useState("");
  const [value, setValue] = useState("");
  const [searches, setSearches] = useState(true);
  const [date, setDate] = useState("");
  const [count, setCount] = useState([]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  function convert1(str) {
    var date1 = new Date(str),
      mnth = ("0" + (date1.getMonth() + 1)).slice(-2),
      day = ("0" + date1.getDate()).slice(-2);
    return [date1.getFullYear(), mnth, day].join("-");
  }
  const day1 = convert1(date).slice(8);

  const handleDate = (date, quantity) => {
    setCount([...count, { day_of_month: date, quantity: quantity }]);
  };
  const handleAddition = (date) => {
    const quantity = [...count];
    const index = count?.findIndex(
      (day_of_month) => day_of_month.day_of_month === date
    );
    quantity[index].quantity++;
    setCount(quantity);
  };
  const handleSubstration = (date) => {
    const quantity = [...count];
    const index = count?.findIndex(
      (day_of_month) => day_of_month.day_of_month === date
    );
    quantity[index].quantity--;
    setCount(quantity);
  };

  useEffect(() => {
    date !== "" && handleDate(day1, 0);
  }, [day1]);

  // console.log(convert1(date).slice(8));
  const GetSubscriptionDaly = () => {
    // const reqbody = new FormData();
    // reqbody.append("subscription_plan_id", id);
    // reqbody.append("product_variants_id", 1);
    // reqbody.append("start_date", convert(value1));
    // reqbody.append("select_quantity", count);

    const reqbody = {
      subscription_plan_id: id,
      product_variants_id: variant_id,
      monthly_subscription_details: {
        start_date: convert(value1),
        days: count,
      },
    };
    axiosInstance
      .post(API_URLS.monthlySubscription, reqbody)
      .then((response) => {
        alert(response?.data?.message);
        navigate("/subscription");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // console.log(day1);

  return (
    <>
      <div className="flex my-5">
        <div className="flex px-5">
          <div className="px-5">
            <img
              src="https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_1280.jpg"
              alt=""
              className="h-20 w-20 "
            />
          </div>
          <div className=" flex flex-col justify-start items-start">
            <p className="font-bold">Tender Coconut clean & Peeled</p>
            <p className="text-gray-300">1 pc</p>
          </div>
        </div>
      </div>
      {!searches ? (
        <>
          <div className="flex justify-center items-center">
            <p className="font-bold">Select Date(s) for monthly deluverd</p>
          </div>

          <div className="my-10 flex justify-center px-5">
            <Calendar onChange={setValue1} value={value1} />
          </div>

          <div className="flex gap-20 px-10 my-5  ">
            <p className="font-bold text-xl">Date</p>
            <p className="font-bold">{convert(value1)}</p>
          </div>
          <div className="flex justify-center items-center my-5">
            <Button onClick={GetSubscriptionDaly} variant="contained">
              Confirm
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="flex justify-center items-center">
            <p className="font-bold">Select Date(s) for monthly deluverd</p>
          </div>

          <div className="my-10 flex justify-center px-5">
            <Calendar onChange={setDate} value={date} />
          </div>
          <div className="flex flex-col justify-between items-center w-full px-3 my-2">
            {count?.map((i) => {
              return (
                <>
                  <div className="flex flex-row justify-between items-center w-full px-3 my-2">
                    <div className="flex ">
                      <p className="text-gray-600 text-xl ">{i.day_of_month}</p>
                    </div>
                    <span className="flex gap-1">
                      <span
                        className="bg-blue-200 p-3 rounded-md"
                        onClick={() =>
                          i.quantity !== 0 && handleSubstration(i.day_of_month)
                        }
                      >
                        -
                      </span>
                      <span className="bg-blue-200 p-3 rounded-md">
                        {i.quantity}
                      </span>
                      <span
                        className="bg-blue-200 p-3 rounded-md"
                        onClick={() =>
                          i.quantity !== 100 && handleAddition(i.day_of_month)
                        }
                      >
                        +
                      </span>
                    </span>
                  </div>
                </>
              );
            })}
          </div>
          <div className="flex justify-center items-center my-5">
            <Button
              onClick={() => {
                setSearches(false);
              }}
              variant="contained"
            >
              Next
            </Button>
          </div>
        </>
      )}
    </>
  );
}
